import { installRuntimeConfig, loadRuntimeConfig } from "_shared/runtime-config/runtime-config";
import { showRuntimeConfigFailure } from "_shared/runtime-config/runtime-config-failure";

/**
 * The page's entry: reads this environment's `/config.json`, then imports the application.
 *
 * One bundle serves every environment (#7516), so nothing in it says which API to call until this
 * file has loaded. `meta.ts` and `config.ts` read the configuration when they are first imported,
 * and the application imports them, so `index.tsx` is imported only once it is installed. Keep this
 * file's own imports to the configuration: anything else could reach `meta.ts` first.
 */
export async function startApplication(
  container: HTMLElement,
  importApplication: () => Promise<unknown>,
): Promise<void> {
  try {
    installRuntimeConfig(await loadRuntimeConfig());
  } catch (error) {
    console.error(error);
    showRuntimeConfigFailure(container, error);
    return;
  }

  await importApplication();
}

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root element not found");
}

void startApplication(container, () => import("./index"));
